import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { apiHost } from '../helper/apiHost';
import fallbackLogo from '../assets/img/uniper-logo.png';

export function useWebsiteLogo(token) {
    const [logoUrl, setLogoUrl] = useState(fallbackLogo);
    const [loading, setLoading] = useState(true);

    const loadLogo = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get('api/website-settings/logo', {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                withCredentials: true,
            });
            if (res.data?.url) {
                setLogoUrl(`${apiHost}${res.data.url}?t=${Date.now()}`);
            } else {
                setLogoUrl(fallbackLogo);
            }
        } catch {
            setLogoUrl(fallbackLogo);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        loadLogo();
    }, [loadLogo]);

    useEffect(() => {
        const handleLogoUpdated = () => loadLogo();
        window.addEventListener('website-logo:updated', handleLogoUpdated);
        return () => window.removeEventListener('website-logo:updated', handleLogoUpdated);
    }, [loadLogo]);

    return { logoUrl, loading, reloadLogo: loadLogo };
}
